import React, { useEffect, useState } from 'react'
import { Modal, Button, Input, Table, Space, Form, notification, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, RetweetOutlined, FileExcelOutlined, FundViewOutlined } from '@ant-design/icons';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';

const InventarioFisico = () => {

    // VARIABLES
    const urlGetInventarios = 'https://hcrm.gpoptima.info/api/cypo/inventario-fisico/getInventarios';
    const urlDeleteInventario = 'https://hcrm.gpoptima.info/api/cypo/inventario-fisico/deleteInventario/';
    const urlAddInventario = 'https://hcrm.gpoptima.info/api/cypo/inventario-fisico/insertInventario/';
    const urlEditInventario = 'https://hcrm.gpoptima.info/api/cypo/inventario-fisico/editInventario/';
    const urlExportExcel = 'https://hcrm.gpoptima.info/api/cypo/inventario-fisico/export';
    const urlViewDetails = 'https://hcrm.gpoptima.info/api/cypo/inventario-fisico/viewDetails/';

    // STATES
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [titleModal, setTitleModal] = useState('');
    const [textButton, setTextButton] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [modalViewDetails, setModalViewDetails] = useState(false);
    const [action, setAction] = useState('');
    const [register, setRegister] = useState(0);
    const [nombreInventario, setNombreInventario] = useState('');
    const [dataDetails, setDataDetails] = useState([]);

    // EFECTS
    useEffect(() => {
        fetchData();
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        if (action == 'add') {
            setNombreInventario('');
        }
    }, [action])

    // FUNCTIONS
    const fetchData = () => {
        setLoading(true);
        fetch(urlGetInventarios)
            .then((res) => res.json())
            .then(result => {
                setData(result.data);
                setLoading(false);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: 200,
                    },
                });
            });
    }

    const cancel = (e) => { };

    const handleDelete = id => {
        fetch(`${urlDeleteInventario}${id}`)
        .then((res) => res.json())
        .then(result => {
            if (result.message == 'Eliminado') {
                message.success('Se elimino correctamente el registro');
                fetchData();
            } else {
                message.error('No se pudo eliminar el registro. Favor de volver a intentarlo');
            }
        });
    }

    const edit = (id, nombre) => {
        setTitleModal(`Editar - ${nombre}`);
        setOpenModal(true);
        setTextButton('Editar');
        setAction('edit');
        setRegister(id);
        setNombreInventario(nombre);
    }

    const viewDetails = (id) => {
        setModalViewDetails(true);

        fetch(`${urlViewDetails}${id}`)
            .then((res) => res.json())
            .then(result => {
                const { data } = result;
                setDataDetails(data);
            });
    }

    const handleSubmit = () => {
        const name = nombreInventario.replace(/ /g, '_');

        if (action == "add") {
            fetch(`${urlAddInventario}${name}`)
                .then((res) => res.json())
                .then(result => {
                    if (result.message == 'Insertado') {
                        openNotification('Proceso exitoso', 'Se ha registrado un nuevo inventario correctamente');
                    } else {
                        openNotification('Error en el proceso', 'No se ha podido generar un nuevo registro');
                    }
                });
        }

        if (action == "edit" && register != 0) {
            fetch(`${urlEditInventario}${register}/${name}`)
                .then((res) => res.json())
                .then(result => {
                    if (result.message == 'Editado') {
                        openNotification('Proceso exitoso', `Se ha editado correctamente el inventario`);
                    } else {
                        openNotification('Error en el proceso', 'No se ha podido editar este registro');
                    }
                });
        }

        setOpenModal(false);
        fetchData();
    }

    const openNotification = (message, description) => {
        notification.open({
            message,
            description,
            duration: 3
        });
    };

    const exportInventarioExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Inventario Fisico');

        fetch(`${urlExportExcel}`)
            .then((res) => res.json())
            .then(result => {
                const { data } = result;

                worksheet.columns = [
                    { header: 'Fecha de registro', key: 'date' },
                    { header: 'Nombre del inventario', key: 'name' },
                    { header: 'Numero de partes', key: 'num_parts' },
                    { header: 'Cantidad total', key: 'quantity' }
                ];

                data.forEach(element => {
                    const { fecharegistro, nombre, numeroparte, total_cantidad } = element;

                    const fecha = new Date(fecharegistro);
                    const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
                    const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

                    worksheet.addRow({ date: fechaFormateada, name: nombre, num_parts: numeroparte.trim(), quantity: total_cantidad });
                });

                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer]), 'inventario_fisico_2023.xlsx');
                });
            });
    }

    // TABLE CONFIG
    const columns = [
        {
            title: 'FECHA DE CREACIÓN',
            dataIndex: 'fecharegistro',
            width: '20%',
            render: (_, data) => {
                const fecha = new Date(data.fecharegistro);
                const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
                const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

                return fechaFormateada.toUpperCase();
            }
        },
        {
            title: 'INVENTARIO',
            dataIndex: 'nombre',
            width: '20%',
            render: (_, data) => {
                return data.nombre.toUpperCase();
            }
        },
        {
            title: 'ACCIÓN',
            dataIndex: 'accion',
            width: '20%',
            render: (_, data) => (
                <Space size="middle">
                    <FundViewOutlined onClick={() => {
                        const { id } = data;
                        viewDetails(id);
                    }} />
                    <EditOutlined onClick={() => {
                        const { id, nombre } = data;
                        edit(id, nombre);
                    }} />
                    <Popconfirm
                        title="¿Eliminar este registro?"
                        // description="¿Estas seguro que deseas eliminar este registro?"
                        onConfirm={() => handleDelete(data.id)}
                        onCancel={cancel}
                        okText="Eliminar"
                        cancelText="Cancelar"
                    >
                        <DeleteOutlined />
                    </Popconfirm>
                </Space>
            ),
        }
    ]

    const columnsDetails = [
        {
            title: 'FECHA DE CREACIÓN',
            dataIndex: 'fecharegistro',
            width: '20%',
            render: (_, data) => {
                const fecha = new Date(data.fecharegistro);
                const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
                const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

                return fechaFormateada.toUpperCase();
            }
        },
        {
            title: 'NÚMERO DE PARTES',
            dataIndex: 'numeroparte',
            width: '20%',
            render: (_, data) => {
                return data.numeroparte;
            }
        },
        {
            title: 'CANTIDAD',
            dataIndex: 'otal_cantidad',
            width: '20%',
            render: (_, data) => {
                return data.total_cantidad;
            }
        },
    ];

    return (
        <div style={{ padding: '2rem' }}>
            <div style={{ marginBottom: '1rem' }}>
                <span style={{ fontSize: '1.2rem' }}>Inventeario Fisico</span>
            </div>

            <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'end' }}>
                <Button
                    type="danger"
                    size={'small'}
                    onClick={() => {
                        exportInventarioExcel();
                    }}
                >
                    <FileExcelOutlined />
                </Button>

                <Button
                    type="primary"
                    size={'small'}
                    onClick={() => {
                        setTitleModal('Nuevo inventario');
                        setTextButton('Registrar');
                        setOpenModal(true);
                        setAction('add');
                    }}
                >
                    <PlusOutlined />
                </Button>
                <Button
                    type="primary"
                    size={'small'}
                    onClick={() => {
                        fetchData();
                    }}
                >
                    <RetweetOutlined />
                </Button>

            </div>

            <div style={{ padding: '1rem', border: '1px solid #e1e1e1' }}>
                <Table
                    columns={columns}
                    rowKey={(record) => record.id}
                    loading={loading}
                    dataSource={data}
                    id="table-inventario"
                />
            </div>

            {/* NEW / EDIT MODAL */}

            <Modal
                title={titleModal}
                open={openModal}
                onCancel={() => { setOpenModal(false) }}
                footer={[
                    <Button key="submit" type="primary" onClick={() => handleSubmit()}>
                        {textButton}
                    </Button>,
                    <Button key="back" onClick={() => {
                        setAction('');
                        setRegister(0);
                        setOpenModal(false);
                    }}>
                        Cancelar
                    </Button>
                ]}
            >
                <Form
                    layout="vertical"
                    autoComplete="off"
                >
                    <Form.Item label="Nombre de inventario" >
                        <Input placeholder='Ingresa el nombre del inventario' value={nombreInventario} onChange={e => { setNombreInventario(e.target.value); }} />
                    </Form.Item>
                </Form>
            </Modal>

            {/* VIEW DETAILS */}

            <Modal
                title='DETALLES'
                open={modalViewDetails}
                onCancel={() => { setModalViewDetails(false) }}
                footer={[]}
            >
                <Table
                    columns={columnsDetails}
                    rowKey={(record) => record.id}
                    loading={loading}
                    dataSource={dataDetails}
                    id="table-inventario"
                />
            </Modal>
        </div>


    )
}

export default InventarioFisico
